import React from "react";

import CancelIcon from "@mui/icons-material/Cancel";
import IconBtnTemplate from "./IconBtnTemplate";

type IconSize = "small" | "inherit" | "medium" | "large";
type ButtonType = "success" | "danger" | "warning" | "info" | "generic";

interface CancelIconBtnProps {
  action: (event?: React.MouseEvent<HTMLButtonElement>) => void;
  type?: ButtonType;
  size?: IconSize;
  tip?: string;
}

export default function CancelIconBtn({
  action,
  type = "danger",
  size = "medium",
  tip = "Cancel",
}: CancelIconBtnProps) {
  return (
    <IconBtnTemplate
      type={type}
      action={action}
      icon={<CancelIcon fontSize={size} />}
      tip={tip}
    />
  );
}
